import { CircularProgress, IconButton } from "@mui/material"
import { DraftOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { useEffect } from "react"

import { useGetFileUploadData } from "@/components/upload/hooks/useGetFileUploadData"
import { handleFileAction } from "@/components/upload/utils"
import { ReferenceTableName } from "@/graphql/codegen/graphql"

interface FileIconCellProps {
  competitorProductId: string
}

export const FileIconCell: FC<FileIconCellProps> = ({ competitorProductId }) => {
  const { fileList, fileFetching, refetchFileUploadData } = useGetFileUploadData({
    referenceId: competitorProductId,
    referenceTableName: ReferenceTableName.CompetitorProduct,
    pause: true,
  })

  useEffect(() => {
    if (!fileFetching && fileList.length > 0) {
      const file = fileList[0]
      void handleFileAction(file)
    }
  }, [fileFetching, fileList])

  const onFileClick = () => {
    if (fileFetching) return
    refetchFileUploadData()
  }

  return (
    <IconButton
      onClick={onFileClick}
      size='small'
      aria-label='download or view file'
      className='text-primary hover:text-primary-700'
      disabled={fileFetching}
    >
      {fileFetching ? <CircularProgress size={20} /> : <DraftOutlined color='primary' />}
    </IconButton>
  )
}
